import styled from "styled-components";

export const ApiErrorsContainer = styled.div.attrs({
  className: "api-errors"
})`
  display: flex;
  padding: 20px;
  background-color: #fafafa;
`;
